import { Team__Nogaleras } from "../teams/Nogaleras";
import { Team__Potras } from "../teams/Potras";
import { Team__Pythons } from "../teams/Pythons";
import { Team__Raptors } from "../teams/Raptors";
import { Team__UTPaquime } from "../teams/UTPaquime";

const Nogaleras = {
  team: Team__Nogaleras,
  playingPlayers: [],

  goals: 26,
  penaltyGoals: 0,
  isWinner: false,
};

const Raptors = {
  team: Team__Raptors,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const UTPaquime = {
  team: Team__UTPaquime,
  playingPlayers: [],

  goals: 24,
  penaltyGoals: 0,
  isWinner: false,
};

const Potras = {
  team: Team__Potras,
  playingPlayers: [],

  goals: 16,
  penaltyGoals: 0,
  isWinner: false,
};

const Pythons = {
  team: Team__Pythons,
  playingPlayers: [],

  goals: 37,
  penaltyGoals: 0,
  isWinner: false,
};

export const Jornada4 = {
  jornadaPosition: 4,
  matches: [

        {
      team1: Pythons,
      team2: Potras,

      isCompleted: true,
      isPlaying: false,
      day: "Jueves",
      date: "2025-07-31",
      time: "13:00:00",
      location: "Centro Recreativo Lebaron",
    },
    
    {
      team1: UTPaquime,
      team2: Nogaleras,

      isCompleted: true,
      isPlaying: true,
      day: "Jueves",
      date: "2025-07-31",
      time: "18:00:00",
      location: "Centro Recreativo Lebaron",
    },
  ],
};
